import { useMemo } from 'react';

const useTimeListGenerator = (input: number, interval = 1) => {
  const list = useMemo(() => {
    const timeList: Array<{ text: string; value: string }> = [];
    for (let i = 0; i < input; i += interval) {
      const paddedText = String(i).padStart(2, '0');
      timeList.push({ text: paddedText, value: paddedText });
    }
    return timeList;
  }, [input, interval]);

  return list;
};

export default useTimeListGenerator;
